var _defs, _rect, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 520,
    viewBox: "0 0 400 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 400,
    y2: 520,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F4E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2A33"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 205,
    r: 62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 285c-66 0-120 42-120 94v8h240v-8c0-52-54-94-120-94z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 470,
    fill: "#FFFFFF",
    fillOpacity: 0.7,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    textAnchor: "middle"
  }, "Evento Professional")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultService);
export default __webpack_public_path__ + "static/media/DefaultService.2d97fe5b21c88abea147b560a85525b8.svg";
export { ForwardRef as ReactComponent };